module.exports = __webpack_public_path__ + "static/media/confluence.e18ee343.svg";